module.exports = __webpack_public_path__ + "static/media/search_icon.050630c3.svg";